// extracted by mini-css-extract-plugin
export default {"container":"BottomBar_container__-h7nZ","tab":"BottomBar_tab__XiI2K","tab-active":"BottomBar_tab-active__E7YVq"};